/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_Rental_List7Inputs */

const es_footer_link_rental_list7 = /** @type {(inputs: Footer_Link_Rental_List7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Alquiler · Lista 7ª`)
};

const gl_footer_link_rental_list7 = /** @type {(inputs: Footer_Link_Rental_List7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Alugueiro · Lista 7ª`)
};

const en_footer_link_rental_list7 = /** @type {(inputs: Footer_Link_Rental_List7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Rental · List 7`)
};

/**
* | output |
* | --- |
* | "Zarpar Rental · List 7" |
*
* @param {Footer_Link_Rental_List7Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_link_rental_list7 = /** @type {((inputs?: Footer_Link_Rental_List7Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_Rental_List7Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_footer_link_rental_list7(inputs)
	if (locale === "en") return en_footer_link_rental_list7(inputs)
	return es_footer_link_rental_list7(inputs)
});